var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TextEditor',{attrs:{"entity":_vm.size,"label":"Størrelse","alias":"name","validate":true,"scope":"field"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }